import type { Session } from './storage';

export type AuthState = {
  session: Session | null;
};

export type AuthAction =
  | { type: 'setSession'; session: Session }
  | {
      type: 'switchWorkspace';
      accountName: string;
      accountId: string;
      displayName: string;
    }
  | { type: 'clearSession' };

/**
 * Pure reducer for AuthContext state. Side effects (localStorage I/O, API
 * instance creation, sessionStorage flag for logout) live in the provider,
 * not here.
 */
export function authReducer(state: AuthState, action: AuthAction): AuthState {
  switch (action.type) {
    case 'setSession':
      return { session: action.session };
    case 'switchWorkspace': {
      if (!state.session) {
        return state;
      }
      return {
        session: {
          ...state.session,
          accountName: action.accountName,
          accountId: action.accountId,
          workspaceDisplayName: action.displayName,
        },
      };
    }
    case 'clearSession':
      return { session: null };
  }
}
